// Chapter.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Chapter(){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const bookChapterList = useSelector((state) => state.chapter.bookChapterList);
  const bookChapterListItemSelected = useSelector((state) => state.chapter.bookChapterListItemSelected);
  //const open1 = useSelector((state) => state.chapter.open1);
  const bookList = useSelector((state) => state.home.bookList);
  const verseReadLogList4Book = useSelector((state) => state.home.verseReadLogList4Book);
  const bookChapter = useSelector((state) => state.home.bookChapter);
  //const credential = useSelector((state) => state.signIn.credential);

  const chapter4SetOpen1= () => {
    dispatch(setOpen1(true));
  };

  const chapter4SetBookChapter = (e) => {
    dispatch(setBookChapter({ ...bookChapter, chapter: e }));
  };

  const chapterRead = (book, chapter) => {  
      let exists = verseReadLogList4Book.some(item => item.book === book && item.chapter === chapter)
      if (exists) {
        return SPACE + '(已讀)'
      } else {
        return null;
      }
  }

  const handleOnChange = (e) => {
    let value = e.target.value;
    dispatch(setBookChapterListItemSelected(value));
    chapter4SetBookChapter(value);
  };

  const handleDialogOpen1 = (e) => {
    chapter4SetOpen1();
  }

  useEffect(() => {
    if (bookChapter.book > 0){
      getVerseReadLogList4Book('Chapter');
      // setVerseReadLogList4Book(list);
      const bookChapterList = [];
      for (let i = 1; i <= bookList[bookChapter.book-1].Chapters; i++) {
        bookChapterList.push({ book: bookChapter.book, chapter: i });
      }
      dispatch(setBookChapterList(bookChapterList));
    }
  }, [bookChapter.book]);

  if (bookChapter.book === 0) {

    return null;

  } else {

    return (
      
      <div>

          <Box
            sx={{
              borderRadius: '4px', // typical MUI chip border radius
              border: '1px solid',
              borderColor: 'primary.main',
              display: 'flex',
              height: 19, // typical chip height
              padding: 1,
            }}
          >

            <Select
              value={bookChapterListItemSelected}
              onChange={handleOnChange}
              input={<InputBase />}
              fullWidth
            >

              {bookChapterList.map(bookChapterListItem => (
                <MenuItem key={bookChapterListItem.chapter} value={bookChapterListItem.chapter}>
                  {getChapterChineseName(bookChapterListItem)} {chapterRead(bookChapter.book, bookChapterListItem.chapter)}
                </MenuItem>
              ))}

            </Select>   

            <IconButton
              sx={{
                borderRadius: 0,
                bgcolor: 'primary.main',
                '&:hover': { bgcolor: 'primary.main' },
                margin: -1
              }}
              onClick={handleDialogOpen1}
            >
              <CheckIcon sx={{ color: 'white' }} />
            </IconButton>        

          </Box>

      </div>
    )
  }
}